import type { SupportedLanguage } from "./i18n/index";

const makeWordpressLink = (
  urlPath: string,
  locale: SupportedLanguage,
): string => {
  return [
    "https://www.mightier.com",
    locale === "en" ? "" : locale.toLowerCase(), // en doesn't need locale specified in URL
    urlPath.startsWith("/") ? urlPath.substring(1) : urlPath,
  ].join("/");
};

const makeKnowledgeBaseLink = (
  urlPath: string,
  locale: SupportedLanguage,
): string => {
  return [
    "https://support.mightier.com/hc",
    getKnowledgeBaseLocale(locale.toLowerCase()),
    urlPath.startsWith("/") ? urlPath.substring(1) : urlPath,
  ].join("/");
};

// Zendesk knowledge base locales are different from i18n locales
const getKnowledgeBaseLocale = (locale: string): string => {
  if (locale === "en") {
    return "en-us";
  } else if (locale === "uk") {
    return "uk-ua";
  } else {
    return locale;
  }
};

export const staticLinks = {
  faqs: (lng: SupportedLanguage): string => {
    return makeKnowledgeBaseLink("", lng);
  },
  contactPage: (lng: SupportedLanguage): string => {
    return makeWordpressLink("contact-us/", lng);
  },
  termsOfService: (lng: SupportedLanguage): string => {
    return makeWordpressLink("terms-of-use/", lng);
  },
  privacyPolicy: (lng: SupportedLanguage): string => {
    return makeWordpressLink("privacy-policy/", lng);
  },
  loginToHub: "https://hub.mightier.com/login/",
  facebook: "https://www.facebook.com/bemightier/",
  x: "https://twitter.com/mightier_",
  linkedin: "https://www.linkedin.com/company/mightier/posts/",
};
